module.exports = __webpack_public_path__ + "static/media/map-outline-02.eb3922f1.svg";